import React, { useState, Fragment, useLayoutEffect } from "react";
import "./CommonStyle/CommonStyle.css";
import Collapse from "@mui/material/Collapse";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";

import ListItemIcon from "@mui/material/ListItemIcon";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { DrawerURLs } from "../Drawer/DrawerContext/DrawerURLs";
import { useLocation } from "react-router";

const CustomListItem = (props, key) => {
  const [open, setOpen] = useState(false);

  const handleClick = (propOnClick) => {
    return (ev) => {
      if (propOnClick) {
        propOnClick(ev);
      }

      setOpen(!open);
    };
  };

  const moreIcon = open ? (
    <ExpandLess className="expandless-button" />
  ) : (
    <ExpandMore className="expandless-button" />
  );

  const selectedDrawer = DrawerURLs()?.Urls?.filter(
    (x) => x?.name === props?.text
  )[0];

  const selectedDrawerChildren = DrawerURLs()?.Urls?.filter(
    (x) => x?.name === props?.text
  )[0]?.children;

  const location = useLocation();
  const presentURL =
    location?.pathname?.split("/")[2] || location?.pathname?.split("/")[1];

  const presentDrawerURL =
    selectedDrawer?.href?.split("/")[2] ||
    selectedDrawer?.href?.split("/")[1] ||
    selectedDrawerChildren?.[0]?.href?.split("/")[2];
  // console.log(presentURL, presentDrawerURL);
  // console.log(selectedDrawer?.name, props?.text);

  useLayoutEffect(() => {
    presentURL === presentDrawerURL && setOpen(!open);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [presentDrawerURL]);

  return (
    <Fragment>
      <ListItemButton
        // key={+key * Math.random()}
        className={`list-button ${
          presentURL === presentDrawerURL && "list-button-active"
        }`}
        selected={!!props.selected}
        onClick={handleClick(props.onClick)}
        href={props.href || null}

        // style={{
        //   backgroundColor: presentURL === presentDrawerURL && "red",
        // }}
      >
        <ListItemIcon className="list-icons">
          {props.icon}
        </ListItemIcon>
        <ListItemText
          // key={+key * Math.random()}
          className="list-item-text"
          primary={props.text || ""}
        />
        {!props.children ? null : moreIcon}
      </ListItemButton>
      {!props.children ? null : (
        <Collapse
          className="list-collapse"
          in={open}
          timeout="auto"
          unmountOnExit
          // key={+key * Math.random()}
        >
          {props.children}
        </Collapse>
      )}
    </Fragment>
  );
};

export default CustomListItem;
